
export default {

   types: {
      truefalse: { uid: 'truefalse', name: "Vrai ou Faux ?", short:"vrai/faux", icon: 'extension' },
      intruder: { uid: 'intruder', name: "Trouvez l'intrus", short: "intrus", icon: 'cancel' },
      findadish: { uid: 'findadish', name: "Dans quoi y a-t-il ?", short: "dans quoi?", icon: 'search' },
   },
   typeList: ['truefalse', 'intruder', 'findadish'],

   levels: {
      easy: { uid: 'easy', name: "Facile", points: "1 point" },
      medium: { uid: 'medium', name: "Moyen", points: "2 points" },
      expert: { uid: 'expert', name: "Expert", points: "3 points" },
   },
   levelList: ['easy', 'medium', 'expert'],

   diabetes: {
      nodiabetes: { uid: 'nodiabetes', name: "Non diabétique", short: "Non" },
      type1: { uid: 'type1', name: "Type 1", short: "Type 1" },
      type2: { uid: 'type2', name: "Type 2", short: "Type 2" },
   },
   diabetesList: ['nodiabetes', 'type1', 'type2'],

   cholesterols: {
      no: { uid: 'no', name: "Non-hypercholestérolémique", short: "Non hyper" },
      yes: { uid: 'yes', name: "Hypercholestérolémique", short: "Hyper" },
   },
   cholesterolList: ['no', 'yes'],

   sssels: {
      noss: { uid: 'noss', name: "Pas de régime sans sel", short: "Non" },
      ss2g: { uid: 'ss2g', name: "Moins de 2g/j", short: "2g/j" },
      ss4g: { uid: 'ss4g', name: "Moins de 4g/j", short: "4g/j" },
      ss6g: { uid: 'ss6g', name: "Moins de 6g/j", short: "6g/j" },
   },
   ssselList: ['noss', 'ss2g', 'ss4g', 'ss6g'],

}



// WEBPACK FOOTER //
// ./src/utilities/qcuConstants.js